export default "__VITE_ASSET__CvJgQ4BN__"